export const DomainStatus = {
    RegistrationRequested: 1,
    TransferRequested: 2,
    Active: 3,
    InQuarantine: 4,
    Cancelled: 5,
    RegistrationFailed: 7,
    TransferFailed: 9,
    Expired: 10,
};
